import IndustryCards from './IndustryCards'
export default IndustryCards
